import { Alert as ChakraAlert }  from '@chakra-ui/react'
import { colors } from '../../utilities/colors'
import { RiErrorWarningFill } from "react-icons/ri"

export default function Alert({ bgColor, title, children}) {
  return(
    <ChakraAlert.Root bg={bgColor} m={0}>
      <ChakraAlert.Content display='flex' flexDirection='row' alignItems='center' w="full">
        <RiErrorWarningFill className='text-grey-100 text-xl' />
        <ChakraAlert.Title color={colors.grey100} w={300}>{title}</ChakraAlert.Title>
        <ChakraAlert.Description color={colors.grey100} display="flex" flexWrap="wrap">
          {children}
        </ChakraAlert.Description>
      </ChakraAlert.Content>
    </ChakraAlert.Root>
  )
}